import { IsBoolean, IsDateString, IsEmail, IsNotEmpty, IsOptional, IsPhoneNumber } from "class-validator";
import { IAddress } from "../interfaces/address.interface";
import { IBase } from "../interfaces/base.interface";
import { ICustomer, ICustomerShop } from "../interfaces/customer.interface";

export class CustomerDTO implements Omit<ICustomer, keyof IBase | 'token' | 'password' | 'lastLogin' | 'registeredFrom' | 'shops' | 'address'> {

  @IsOptional()
  @IsBoolean()
  optInEmail: boolean;

  @IsOptional()
  @IsBoolean()
  optInLoyalty: boolean;

  @IsOptional()
  @IsBoolean()
  optInSMS: boolean;

  @IsNotEmpty({ message: 'Le prénom est requis' })
  firstname: string;

  @IsNotEmpty({ message: 'Le nom est requis' })
  lastname: string;

  @IsNotEmpty({ message: 'L\'email est requis' })
  @IsEmail({}, { message: 'Le format de l\'email n\'est pas valide' })
  email: string;

  @IsOptional()
  @IsPhoneNumber(null, { message: "Le format du téléphone est incorrect." })
  phone: string;

  @IsOptional()
  @IsDateString({
    message: 'La date de naissance n\'est pas valide'
  })
  birthday: any;

  addresses: IAddress[];

  shops?: ICustomerShop[] | undefined;

}
